/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface CreateOrUpdateTenantFavIconRequest {
    favicon: Blob;
}

/**
 * TenantFavIconApi - interface
 * 
 * @export
 * @interface TenantFavIconApiInterface
 */
export interface TenantFavIconApiInterface {
    /**
     * If it doesn\'t exist, creates it; otherwise updates it.
     * @summary Create or update tenant fav icon.
     * @param {Blob} favicon 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantFavIconApiInterface
     */
    createOrUpdateTenantFavIconRaw(requestParameters: CreateOrUpdateTenantFavIconRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * If it doesn\'t exist, creates it; otherwise updates it.
     * Create or update tenant fav icon.
     */
    createOrUpdateTenantFavIcon(requestParameters: CreateOrUpdateTenantFavIconRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Deletes the tenant favicon
     * @summary Delete favicon
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantFavIconApiInterface
     */
    deleteTenantFavIconRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes the tenant favicon
     * Delete favicon
     */
    deleteTenantFavIcon(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class TenantFavIconApi extends runtime.BaseAPI implements TenantFavIconApiInterface {

    /**
     * If it doesn\'t exist, creates it; otherwise updates it.
     * Create or update tenant fav icon.
     */
    async createOrUpdateTenantFavIconRaw(requestParameters: CreateOrUpdateTenantFavIconRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['favicon'] == null) {
            throw new runtime.RequiredError(
                'favicon',
                'Required parameter "favicon" was null or undefined when calling createOrUpdateTenantFavIcon().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", ["OWNER", "API_KEY"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['favicon'] != null) {
            formParams.append('favicon', requestParameters['favicon'] as any);
        }

        const response = await this.request({
            path: `/api/v1/tenants/favicon`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * If it doesn\'t exist, creates it; otherwise updates it.
     * Create or update tenant fav icon.
     */
    async createOrUpdateTenantFavIcon(requestParameters: CreateOrUpdateTenantFavIconRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createOrUpdateTenantFavIconRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes the tenant favicon
     * Delete favicon
     */
    async deleteTenantFavIconRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", ["OWNER", "API_KEY"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/tenants/favicon`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the tenant favicon
     * Delete favicon
     */
    async deleteTenantFavIcon(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTenantFavIconRaw(initOverrides);
    }

}
